import { LicenseInfo } from '@mui/x-data-grid-pro';

LicenseInfo.setLicenseKey(
  '4c23b83bd38281b97beca585efb5375aTz01MzA0OSxFPTE2OTgyMzU5OTQ2NjksUz1wcm8sTE09cGVycGV0dWFsLEtWPTI='
);

// import {LicenseInfo} from '@mui/x-data-grid-pro';

// const MUI_PRO_LICENSE_KEY: any = process.env.npm_config_MUI_PRO_LICENSE_KEY;
// console.log("MUI_PRO_LICENSE_KEY: ", MUI_PRO_LICENSE_KEY);

// LicenseInfo.setLicenseKey(
//   MUI_PRO_LICENSE_KEY
// );
